import { render, staticRenderFns } from "./AccFooter.vue?vue&type=template&id=2250cbf7"
import script from "./AccFooter.vue?vue&type=script&lang=js"
export * from "./AccFooter.vue?vue&type=script&lang=js"
import style0 from "./AccFooter.vue?vue&type=style&index=0&id=2250cbf7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports